import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { Country } from '../Countries';
import type { IPreset } from './Presets.types';
import { orderBy, where } from 'firebase/firestore';

@Identifiable
@Timestampable
@Untrackable
export class Preset extends AbstractDocument<IPreset> {
  readonly collections = {};
}

export class Presets extends AbstractCollection<Preset, IPreset> {
  static path = 'presets';

  constructor(document: Country) {
    super(document.collection(Presets.path), Preset);
  }

  get() {
    return this.query().get(true);
  }

  get active() {
    return this.query([where('active', '==', true), orderBy('order', 'asc')]);
  }

  async one(slug: string) {
    return this.query([where('slug', '==', slug)]).get(true);
  }

  async activeWithTags(tags: string[]) {
    return this.query([where('active', '==', true), where('tags', 'array-contains-any', tags), orderBy('order', 'asc')]).get(true);
  }
}
